import { BreakpointsRender, CUSTOM_LAPTOP_WIDTH } from '@components';
import { ChallengeTypeEnum } from '@types';

import { LoginSkeleton } from '../login';
import { UpdateCredentialsScreenDesktop } from './updateCredentials.desktop';
import { useUpdateCredentialsHelper } from './updateCredentials.helper';
import { UpdateCredentialsScreenMobile } from './updateCredentials.mobile';

export type UpdateCredentialsScreenProps = {
	isLoading: boolean;
	updateCredentialType: ChallengeTypeEnum | null | undefined;
};

export const UpdateCredentialsScreen = () => {
	const props = useUpdateCredentialsHelper();

	if (props.isLoading) {
		return <LoginSkeleton />;
	}

	return (
		<BreakpointsRender
			mobile={<UpdateCredentialsScreenMobile {...props} />}
			laptop={<UpdateCredentialsScreenDesktop {...props} />}
			customLaptopWidth={CUSTOM_LAPTOP_WIDTH}
		/>
	);
};
